import type { ContentBlock, EditorState } from 'draft-js';
import { RichUtils } from 'draft-js';
import styles from '../textSizeStyles.scss';

export type TextSizeBlockType = 'unstyled' | 'header-two' | 'header-three';

export const textSizeBlockTypes: Array<TextSizeBlockType> = [
  'header-two',
  'header-three',
  'unstyled',
];

export const textSizeStylesFn = (contentBlock: ContentBlock) => {
  const { type } = contentBlock.toJS();

  if (type === 'header-two') {
    return styles.headerTwo;
  } else if (type === 'header-three') {
    return styles.headerThree;
  }
  return '';
};

export const getActiveTextSize = (
  editorState: EditorState,
): TextSizeBlockType => {
  const startKey = editorState.getSelection().getStartKey();
  const contentBlock = editorState.getCurrentContent().getBlockForKey(startKey);
  const { type } = contentBlock.toJS();
  if (type === 'header-two' || type === 'header-three') {
    return type;
  }
  return 'unstyled';
};

export const preventBubblingUp = (
  event: React.MouseEvent<HTMLOrSVGElement>,
) => {
  event.preventDefault();
  event.stopPropagation();
};

export const getStateWithNewTextSize = (
  textSize: string,
  editorState: EditorState,
) => {
  if (getActiveTextSize(editorState) === textSize) {
    return editorState;
  }

  return RichUtils.toggleBlockType(editorState, textSize);
};

export const createStateWithNormalText = (editorState: EditorState) => {
  return getStateWithNewTextSize('unstyled', editorState);
};

export const createStateWithTitle = (editorState: EditorState) => {
  return getStateWithNewTextSize('header-two', editorState);
};

export const createStateWithSubtitle = (editorState: EditorState) => {
  return getStateWithNewTextSize('header-three', editorState);
};
